module.exports = __webpack_public_path__ + "media/react/components/FavouritePlans/SavedSequence/assets/ico-both-0afa7d26d5bff02688dab50c8c210381.svg";